import { render, staticRenderFns } from "./ContactLayoutCustomFieldDisplay.vue?vue&type=template&id=4be3cf52&scoped=true&lang=html"
import script from "./ContactLayoutCustomFieldDisplay.vue?vue&type=script&lang=js"
export * from "./ContactLayoutCustomFieldDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be3cf52",
  null
  
)

export default component.exports